import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthComponent } from './auth/base/components/auth/auth.component';
import { AuthTarget } from './auth/base/models/auth-target.model';
import { authGuard } from './auth/base/guards/auth.guard';
import { AuthenticatedLayoutComponent } from './core/components/authenticated-layout/authenticated-layout.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { MaintenanceModePageComponent } from './pages/maintenance-mode-page/maintenance-mode-page.component';
import { AdminRoleGuard, AnyAdminRoleGuard } from './roles/guards/common-role-guards';
import { AccessDeniedPageComponent } from './pages/access-denied-page/access-denied-page.component';
import { PagesRoleGuard } from './roles/guards/pages.guard';
import { AssetsRoleGuard } from './roles/guards/assets.guard';
import { reportRoutes } from './modules/reports/reports-routes';

const routes: Routes = [
  {
    path: '',
    component: AuthenticatedLayoutComponent,
    canActivate: [authGuard, AnyAdminRoleGuard],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'assets-webspaces',
        canActivate: [AdminRoleGuard],
        loadChildren: () =>
          import('./modules/assets-webspaces/assets-webspaces.module').then((m) => m.AssetsWebspacesModule)
      },
      {
        path: 'pages-webspaces',
        canActivate: [AdminRoleGuard],
        loadChildren: () =>
          import('./modules/pages-webspaces/pages-webspaces.module').then((m) => m.PagesWebspacesModule)
      },
      {
        path: 'languages',
        canActivate: [AdminRoleGuard],
        loadChildren: () => import('./modules/languages/languages.module').then((m) => m.LanguagesModule)
      },
      {
        path: 'origins',
        canActivate: [AdminRoleGuard],
        loadChildren: () => import('./modules/origins/origins.module').then((m) => m.OriginsModule)
      },
      {
        path: 'taxonomies',
        canActivate: [AdminRoleGuard],
        loadChildren: () => import('./modules/taxonomies/taxonomies.module').then((m) => m.TaxonomiesModule)
      },
      {
        path: 'assets',
        canActivate: [AssetsRoleGuard],
        loadChildren: () => import('./modules/assets/assets/assets.module').then((m) => m.AssetsModule)
      },
      {
        path: 'microsites',
        canActivate: [AdminRoleGuard],
        loadChildren: () =>
          import('./modules/micro-navigation/micro-navigation.module').then((m) => m.MicroNavigationModule)
      },
      {
        path: 'site-navigation',
        canActivate: [AdminRoleGuard],
        loadChildren: () =>
          import('./modules/main-navigation/main-navigation.module').then((m) => m.MainNavigationModule)
      },
      {
        path: 'site-settings',
        canActivate: [AdminRoleGuard],
        loadChildren: () => import('./modules/site-settings/site-settings.module').then((m) => m.SiteSettingsModule)
      },
      {
        path: 'pages',
        canActivate: [PagesRoleGuard],
        loadChildren: () => import('./modules/pages/pages.module').then((m) => m.PagesModule)
      },
      {
        path: 'reports',
        canActivate: [AdminRoleGuard],
        children: reportRoutes
      },
      {
        path: 'home',
        component: HomePageComponent
      }
    ]
  },
  {
    path: 'auth',
    component: AuthComponent,
    data: { target: AuthTarget.cms }
  },
  {
    path: 'auth-totara',
    component: AuthComponent,
    data: { target: AuthTarget.totara }
  },
  {
    path: 'maintenance-mode',
    component: MaintenanceModePageComponent
  },
  {
    path: '403',
    component: AccessDeniedPageComponent
  },
  {
    path: '**',
    redirectTo: 'home'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
